<template>
  <cs-view single-view>
    <template #content>
      <iframe id="stbExcursionContainer" :src="excursionUrl"></iframe>
    </template>
  </cs-view>
</template>
<script>
import { mapMutations } from 'vuex';
import { CSBase } from '@complispace/cs-design-system';
import * as types from '../store/mutationTypes';

export default {
  name: 'STBExcursionIframe',

  components: {},

  extends: CSBase,

  data() {
    const queryParams = {
      referrer: 'pcg-nextgen',
      'vendor-sid': '10000001',
      'vendor-client-sid': 'sytassclient.app-dev',
      'excursion-id': 27172,
      'user-email': 'em.test@complispace.com.au',
      'oauth-signature': 'uMS0LptvioYK2v+M73ekafqBlYg='
    };
    const excursionUrl = new URL(
      'https://sytassclient.app-dev.safetripbuilder.com/excursions/27172'
    );

    Object.keys(queryParams).forEach((key) =>
      excursionUrl.searchParams.append(key, queryParams[key])
    );

    return {
      excursionUrl: excursionUrl.toString()
    };
  },
  computed: {},
  async mounted() {
    this.setPageViewType('stb-excursion-iframe');
  },
  methods: {
    ...mapMutations({
      setPageViewType: types.VIEW_TYPE_SET_PAGE_VIEW_TYPE
    })
  }
};
</script>

<style scoped>
#stbExcursionContainer {
  border: 0;
  width: 100%;
  height: 100%;
}
</style>
